import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache
} from "apollo-boost";
import { setContext } from "apollo-link-context";

const inMemoryCache = new InMemoryCache();

const getCookie = name => {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  if (match) return match[1];
  return null;
};

const authLink = setContext((_, { headers }) => {
  // get the authentication token from cookies if it exists
  const token = getCookie("user_auth_token");

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      os: "web",
      "app-version": "1.0.0",
      Authorization: token ? `${token}` : ""
    }
  };
});

const link = new HttpLink({
  credentials: "include",
  uri:
    global.window && window.gon && window.gon.graphql_endpoint
      ? window.gon.graphql_endpoint
      : "/graphql"
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, link]),
  cache: inMemoryCache
});

export default apolloClient;
